var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-auction"},_vm._l((_vm.auctionList),function(auction,id){return _c('SidebarPanelAuctionItem',{key:id,attrs:{"auction":auction}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }